import React from "react";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import skirtLengthSvg from "../../../assets/images/survey-custom/skirt-length.svg";
import SurveyAnswerCustomMap, { IMapConfig } from "./survey-answer-custom-map";

export interface ISurveyAnswerSkirtLengthProps {
    question: ISurveyQuestion;
    value: string | number | Array<string | number> | null;
    onChange: (value: string | number | Array<string | number>) => void;
    onSave?: (value: string | number | Array<string | number>, shouldClose?: boolean) => void;
}

const SKIRT_LENGTH_LABELS: Record<string, string> = {
    mini: "Mini",
    knee: "Przed kolano",
    midi: "Midi",
    maxi: "Maxi",
};

const mapConfig: IMapConfig = {
    type: "label",
    regions: SKIRT_LENGTH_LABELS,
    labelPrefix: "skirt_len_",
    nonClickableKey: "base",
    svgStyle: {
        fill: "none",
        stroke: "rgba(42, 30, 47, 0.42)",
        strokeWidth: 2,
    },
    additionalStyle: `
        /* Make all skirt_len_* regions clickable even if they don't have id */
        [inkscape\\:label^="skirt_len_"],
        *[inkscape\\:label^="skirt_len_"] {
            pointer-events: all;
        }
    `,
};

const SurveyAnswerSkirtLength: React.FC<ISurveyAnswerSkirtLengthProps> = ({
    question,
    value,
    onChange,
    onSave,
}) => {
    return (
        <SurveyAnswerCustomMap
            question={question}
            value={value}
            onChange={onChange}
            onSave={onSave}
            svgPath={skirtLengthSvg}
            mapConfig={mapConfig}
            ariaLabel="Mapa długości spódnicy"
        />
    );
};

export default SurveyAnswerSkirtLength;
